import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  template: `<label class="label text-center {{ 'delegation-' + role }}">{{
    'ClusterDelegation.' + role | translate
  }}</label>`,
  styles: ['label { padding-top: 6px; padding-bottom: 6px; }'],
  selector: 'label-delegation-role',
  imports: [TranslatePipe],
})
export class LabelDelegationRoleComponent {
  @Input() role: string;
}
